import React from "react";
import {Dimmer, Loader} from "semantic-ui-react";

function LoadingIndicator() {
    return <Dimmer active>
        <Loader size={'large'} content='Loading' />
    </Dimmer>
}

export default LoadingIndicator



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/index.js